import apiClient from '@/api/apiClient';
import apiClient2 from '@/api/apiClient';
import { getAuthData } from '../../utils/storeHelpers';

export default {
  namespaced: true,

  state: {
    schema: {},
    hasPermission: null,
    coApplied: {},
    overlay: false,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    hasPermission: (state) => state.hasPermission,
    coApplied: (state) => state.coApplied,
    overlay: (state) => state.overlay,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_PERMISSION(state, hasPermission) {
      state.hasPermission = hasPermission;
    },
    SET_CO_APPLIED(state, coApplied) {
      state.coApplied = coApplied;
    },
    SET_OVERLAY(state, value) {
      state.overlay = value;
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        const res = await apiClient.testCOxListSchema();
        const schema = res?.data ?? {};
        commit('SET_SCHEMA', schema);
      } catch (error) {
        console.error(error);
      }
    },

    async checkPermission({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const numSectionHCP = 800;

        const res = await apiClient.getPermissionsHCP(
          clinicalHistories_id,
          institutions_profes_id,
          numSectionHCP,
        );

        commit('SET_PERMISSION', Boolean(res?.data?.data?.permission));
      } catch (error) {
        console.error(error);
        commit('SET_PERMISSION', false);
      }
    },

    async loadDataTest({ commit, rootState }) {
      try {
        const { clinicalHistories_id } = getAuthData(rootState);
        const res = await apiClient.dataTestCOxList(clinicalHistories_id);
        const coApplied = res?.data?.data ?? {};
        commit('SET_CO_APPLIED', coApplied);
      } catch (error) {
        console.error(error);
      }
    },

    async deleteCo({ commit, rootState }, payload) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const { correctorId, coNameNum } = payload;
        const coNum = parseInt(coNameNum, 10);

        for (let i = 1; i < 56; i++) {
          if (coNum === i) {
            await apiClient.deleteTestCOxList(correctorId, coNameNum, clinicalHistories_id, institutions_profes_id);
          }
        }
        commit('SET_STATUS', 'removed');
      } catch (error) {
        console.error(error);
      }
    },
    
    async coResultDownload({ dispatch }, payload) {
      try {
        const item = payload.item;
        const id = item.coNumId;
        const hcpPlat = item.HCPnum;
        const coEvaNum = item.evalNumber;
        const coNameNum = item.coPlat.substring(4, 100);
        const coNum = parseInt(item.coPlat.substring(4, 100));

        let coResults;
        for (let i = 1; i < 56; i++) {
          if (coNum === i) {
            coResults = await apiClient2[`testCOx${coNameNum}xResults`](id);
          }
        }

        const downloadUrl = window.URL.createObjectURL(new Blob([coResults.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', `HCP-00${hcpPlat}_Co${coNameNum}-${coEvaNum}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        dispatch('toggleOverlay', false);
      } catch (e) {
        console.error(e);
        dispatch('toggleOverlay', false);
      }
    },

    toggleOverlay({ commit }, value) {
      commit('SET_OVERLAY', value);
    },
  },
};
